/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PutPrescriptionSharingAgreementRequestBody,
  PutPrescriptionSharingAgreementRequestBodyFromJSON,
  PutPrescriptionSharingAgreementRequestBodyToJSON,
  PutPrescriptionSharingAgreementResponse,
  PutPrescriptionSharingAgreementResponseFromJSON,
  PutPrescriptionSharingAgreementResponseToJSON,
} from "../models";

export interface PutPrescriptionSharingAgreementRequest {
  counselingId: number;
  putPrescriptionSharingAgreementRequestBody: PutPrescriptionSharingAgreementRequestBody;
}

/**
 *
 */
export class PrescriptionSharingAgreementApi extends runtime.BaseAPI {
  /**
   * Update prescription sharing agreement by patient
   */
  async putPrescriptionSharingAgreementRaw(
    requestParameters: PutPrescriptionSharingAgreementRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PutPrescriptionSharingAgreementResponse>> {
    if (requestParameters.counselingId === null || requestParameters.counselingId === undefined) {
      throw new runtime.RequiredError(
        "counselingId",
        "Required parameter requestParameters.counselingId was null or undefined when calling putPrescriptionSharingAgreement."
      );
    }

    if (
      requestParameters.putPrescriptionSharingAgreementRequestBody === null ||
      requestParameters.putPrescriptionSharingAgreementRequestBody === undefined
    ) {
      throw new runtime.RequiredError(
        "putPrescriptionSharingAgreementRequestBody",
        "Required parameter requestParameters.putPrescriptionSharingAgreementRequestBody was null or undefined when calling putPrescriptionSharingAgreement."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/{counseling_id}/prescription-sharing-agreement`.replace(
          `{${"counseling_id"}}`,
          encodeURIComponent(String(requestParameters.counselingId))
        ),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: PutPrescriptionSharingAgreementRequestBodyToJSON(
          requestParameters.putPrescriptionSharingAgreementRequestBody
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PutPrescriptionSharingAgreementResponseFromJSON(jsonValue)
    );
  }

  /**
   * Update prescription sharing agreement by patient
   */
  async putPrescriptionSharingAgreement(
    requestParameters: PutPrescriptionSharingAgreementRequest,
    initOverrides?: RequestInit
  ): Promise<PutPrescriptionSharingAgreementResponse> {
    return promiseRetry(
      (retry) =>
        this.putPrescriptionSharingAgreementRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
